/**
 * 收货地址模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 新增收货地址
export const addressAdd = (params) => {
  return req.post('/delivery/member/systemAdd', params);
}
// 修改收货地址
export const addressEdit = (params) => {
  return req.put('/delivery/member', params);
}

// 根据患者id查询收货地址 
export const addressList = (patientId) => {
  return req.get(`/delivery/member/patient/list/${patientId}`);
}

// 收货地址列表
export const addressList1 = (params) => {
  return req.get(`/delivery/member/list`, params);
}

// 查询可选配送方式
export const deliveryMethod = (params) => {
  return req.get(`/delivery/rules/getRules`, params)
}
// 删除用户快递信息
export const deleteDelivery = (deliveryMemberIds) => {
  return req.delete(`/delivery/member/${deliveryMemberIds}`)
}